// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__3Jm0_","title":"AfterFrontImage_title__VRbOd"};